import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from 'ui-components/components/checkbox';

import {
  BRANDING_SHOW_ITEM_IMAGES_TOGGLE,
  BRANDING_SHOW_ITEM_SKUS_TOGGLE,
  BRANDING_SHOW_PRICES_TOGGLE,
} from '../../../../../constants/analytics-events';
import { Segment } from '../../../../../services/analytics-services/segment';
import { useUpdateBrandingContext } from '../context';

import messages from './messages';
import style from './style.module.less';

const CustomOrderDetails = ({ customBranding, disabled = false, source = null }) => {
  const { updateCustomBranding } = useUpdateBrandingContext();
  const {
    show_details: showDetails,
    show_item_images: showItemImages,
    show_prices: showItemPrices,
    show_item_skus_and_options: showItemSkusAndOptions,
  } = customBranding;

  const updateShowItemImages = useCallback(() => {
    Segment.trackEvent(BRANDING_SHOW_ITEM_IMAGES_TOGGLE, { isEnabled: !showItemImages, source });
    updateCustomBranding('show_item_images', !showItemImages);
  }, [showItemImages, source, updateCustomBranding]);

  const updateShowSkus = useCallback(() => {
    Segment.trackEvent(BRANDING_SHOW_ITEM_SKUS_TOGGLE, { isEnabled: !showItemSkusAndOptions, source });
    updateCustomBranding('show_item_skus_and_options', !showItemSkusAndOptions);
  }, [showItemSkusAndOptions, source, updateCustomBranding]);

  const updateShowItemPrices = useCallback(() => {
    Segment.trackEvent(BRANDING_SHOW_PRICES_TOGGLE, { isEnabled: !showItemPrices, source });
    updateCustomBranding('show_prices', !showItemPrices);
  }, [showItemPrices, source, updateCustomBranding]);

  return (
    <div className={style['order-details-branding']}>
      <Checkbox
        checked={showItemImages}
        className={style['details-checkbox']}
        disabled={!showDetails || disabled}
        label={<FormattedMessage {...messages.showItemImages} />}
        onChange={updateShowItemImages}
      />

      <Checkbox
        checked={showItemSkusAndOptions}
        className={style['details-checkbox']}
        disabled={!showDetails || disabled}
        label={<FormattedMessage {...messages.showItemSkusAndOptions} />}
        onChange={updateShowSkus}
      />

      <Checkbox
        checked={showItemPrices}
        className={style['details-checkbox']}
        disabled={!showDetails || disabled}
        label={<FormattedMessage {...messages.showPrices} />}
        onChange={updateShowItemPrices}
      />

      {(!showDetails || disabled) && <div className={style['disabled-mask']} />}
    </div>
  );
};

CustomOrderDetails.propTypes = {
  customBranding: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  source: PropTypes.string,
};

export default CustomOrderDetails;
